module.exports = __webpack_public_path__ + "img/submit-xxc.edd5f5fe.png";